import {
  canUserCustomAttributeBeEdited,
  canUserCustomAttributeBeViewed,
  getMergedOptionGroupOptions
} from '.';

import type { Locales, RequestUser, UserCustomAttribute } from 'shared-types';

type Params = {
  language: Locales;
  userCustomAttributes: UserCustomAttribute[];
} & (
  | {
      onlyEditable: true;
      onlyViewable?: never;
      requestUser: RequestUser;
    }
  | {
      onlyEditable?: never;
      onlyViewable: true;
      requestUser: RequestUser;
    }
  | {
      onlyEditable?: never;
      onlyViewable?: never;
      requestUser?: never;
    }
);

const getAttributesWithMergedOptions = ({
  language,
  onlyEditable,
  onlyViewable,
  requestUser,
  userCustomAttributes
}: Params) => {
  let attributesWithMergedOptions: (UserCustomAttribute & {
    mergedOptions?: { key: string; label: string }[];
  })[] = [];

  userCustomAttributes.forEach((attribute) => {
    if (
      attribute.type === 'ArrayWithOptions' ||
      attribute.type === 'StringWithOptions'
    ) {
      const mergedOptions = getMergedOptionGroupOptions({
        language,
        optionGroups: attribute.optionGroups
      });
      attributesWithMergedOptions.push({ ...attribute, mergedOptions });
    } else {
      attributesWithMergedOptions.push(attribute);
    }
  });

  if (onlyViewable) {
    attributesWithMergedOptions = attributesWithMergedOptions.filter(
      (attribute) =>
        canUserCustomAttributeBeViewed({
          user: requestUser,
          userCustomAttribute: attribute
        })
    );
  }

  if (onlyEditable) {
    attributesWithMergedOptions = attributesWithMergedOptions.filter(
      (attribute) =>
        canUserCustomAttributeBeEdited({
          user: requestUser,
          userCustomAttribute: attribute
        })
    );
  }

  return attributesWithMergedOptions;
};

export default getAttributesWithMergedOptions;
